import { createApiClient } from "@polargold/pg-frontend-core";
import { i18n } from "@/i18n";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";

const accessTokenStorage = new StorageHelper(StorageName.AccessToken, false);

// No onForbidden/onServerError - this app has no response interceptor today (each call site
// handles its own errors). Accept-Language follows the active vue-i18n locale, which
// `useAppLanguageStore` keeps in sync with the user's chosen language ("en_US" -> "en").
const getAcceptLanguage = () => i18n.global.locale.split("_")[0] ?? "en";

export const apiClient = createApiClient({
    baseURL: import.meta.env.VITE_API_URL,
    getAccessToken: () => accessTokenStorage.read<string>(),
    getAcceptLanguage,
});
